'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.useWindowSize = useWindowSize;
exports.useLocalStorage = useLocalStorage;
exports.useCheck = useCheck;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ThemeProvider = require('./theme/ThemeProvider');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useWindowSize() {
  var isClient = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _useState = (0, _react.useState)(getSize),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount  

  return windowSize;
}

function getSavedValue(key, initialValue) {
  // const savedValue = JSON.parse(localStorage.getItem(key))
  var savedValue = localStorage.getItem(key);
  if (savedValue) return savedValue;
  if (initialValue instanceof Function) return initialValue();
  return initialValue;
}

function useLocalStorage(key) {
  if (typeof window === 'undefined') return [null, null];
  if (!key) return;

  var _useState3 = (0, _react.useState)(function () {
    return localStorage.getItem(key);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      val = _useState4[0],
      setValue = _useState4[1];

  (0, _react.useEffect)(function () {
    if (key.includes('password')) return;
    val !== null && localStorage.setItem(key, val);
  }, [val]);
  return [val, setValue];
}

function useCheck() {
  var _useContext = (0, _react.useContext)(_ThemeProvider.ModalsContext),
      checking = _useContext.checking,
      setChecking = _useContext.setChecking;

  function requiresCheck(message, cb) {
    setChecking({
      checking: true,
      message: message,
      cb: cb
    });
  }

  return {
    requiresCheck: requiresCheck
  };
}